import React, { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    if (!/\S+@\S+\.\S+/.test(email)) {
      setMessage("Please enter a valid email address.");
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("email", email);

      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbyP6iq2CCUipVTJts_PH1iIPo0MgsIuRnro9Oj-pJmwRBc9i6frx4dz7vbmb-shiFx8Cg/exec",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.text();
      console.log("Server response:", result); // Debugging

      // Case-insensitive check for success
      if (result.toLowerCase().includes("success")) {
        setMessage("Thank you for subscribing!");
        setIsSuccess(true);
        setEmail('');
      } 
      // Check for various possible duplicate messages
      else if (
        result.toLowerCase().includes("already exists") ||
        result.toLowerCase().includes("duplicate") ||
        result.toLowerCase().includes("already subscribed") ||
        result.toLowerCase().includes("already in") ||
        result.toLowerCase().includes("exists already")
      ) {
        setMessage("This email is already subscribed.");
        setIsSuccess(false);
      } 
      else {
        setMessage("Subscription failed. Please try again. Error: " + result);
        setIsSuccess(false);
      }
    } catch (error) {
      console.error("Error:", error); // Debugging
      setMessage("Network error. Please check your connection.");
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mb-12 px-4 sm:px-6 lg:px-8">
      <div className="bg-gradient-to-r from-teal-600 to-emerald-600 p-6 sm:p-8 rounded-xl shadow-lg border border-emerald-500 w-full max-w-4xl mx-auto">
        <div className="flex flex-col items-center text-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 sm:h-12 sm:w-12 text-white mb-3 sm:mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2 sm:mb-3">Get Health Updates</h3>
          <p className="text-emerald-100 mb-4 sm:mb-6 text-base sm:text-lg max-w-md sm:max-w-2xl">
            Join our newsletter for weekly medical insights and wellness tips delivered straight to your inbox
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full max-w-md sm:max-w-2xl mx-auto">
          <div className="flex-1 relative">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="w-full px-4 py-3 sm:px-5 sm:py-4 rounded-lg sm:rounded-xl bg-white/90 border border-emerald-300 focus:outline-none focus:ring-2 focus:ring-white text-gray-800 placeholder-emerald-400 transition-all text-base sm:text-lg"
              required
              disabled={isLoading}
            />
          </div>
          
          <button
            type="submit"
            disabled={isLoading}
            className={`py-3 px-6 sm:py-4 sm:px-8 rounded-lg sm:rounded-xl font-medium sm:font-semibold text-white transition-all text-base sm:text-lg ${
              isLoading
                ? 'bg-emerald-400 cursor-not-allowed'
                : 'bg-emerald-800 hover:bg-emerald-900 transform hover:scale-[1.02]'
            }`}
          >
            {isLoading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-2 sm:mr-3 h-4 w-4 sm:h-5 sm:w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                {window.innerWidth >= 640 ? 'Subscribing...' : '...'}
              </span>
            ) : (
              window.innerWidth >= 640 ? 'Subscribe Now' : 'Subscribe'
            )}
          </button>
        </form>

        {message && (
          <div className={`mt-3 sm:mt-4 text-center py-2 px-4 sm:py-3 sm:px-4 rounded-lg sm:rounded-lg max-w-md sm:max-w-2xl mx-auto ${
            isSuccess 
              ? 'bg-white/20 text-white' 
              : message.includes("already subscribed")
                ? 'bg-yellow-600/80 text-yellow-100'
                : 'bg-red-900/80 text-red-100'
          }`}>
            {message}
          </div>
        )}

        <div className="mt-3 sm:mt-4 text-center text-xs sm:text-sm text-emerald-100">
          We respect your privacy. Unsubscribe anytime with one click.
        </div>
      </div>
    </div>
  );
};

export default Newsletter;